import './create-oms-order-button/create-oms-order-button.component';
import './create-oms-order-button/create-oms-order-button.scss';

import './delivery-scheduling-form-view/delivery-scheduling-form-view.component';
import './delivery-scheduling-form-view/delivery-scheduling-form-view.scss';

import './oms-3pls-supplier-multi-select/oms-3pls-supplier-multi-select.component';
import './oms-3pls-supplier-multi-select/oms-3pls-supplier-multi-select.scss';

import './oms-automatic-quotes-table/oms-automatic-quotes-table.component';
import './oms-automatic-quotes-table/oms-automatic-quotes-table.scss';

import './oms-automatic-quotes-table-row/oms-automatic-quotes-table-row.component';
import './oms-automatic-quotes-table-row/oms-automatic-quotes-table-row.scss';

import './oms-automatic-shipment-rules-table/oms-automatic-shipment-rules-table.component';
import './oms-automatic-shipment-rules-table/oms-automatic-shipment-rules-table.scss';

import './oms-automatic-shipment-rules-table-row/oms-automatic-shipment-rules-table-row.component';
import './oms-automatic-shipment-rules-table-row/oms-automatic-shipment-rules-table-row.scss';

import './oms-bulk-dispatch-panel/oms-bulk-dispatch-panel.component';
import './oms-bulk-dispatch-panel/oms-bulk-dispatch-panel.scss';

import './oms-import-view/oms-import-view.component';
import './oms-import-view/oms-import-view.scss';

import './oms-order-action-menu/oms-order-action-menu.component';
import './oms-order-action-menu/oms-order-action-menu.scss';

import './oms-order-create-view/oms-order-create-view.component';
import './oms-order-create-view/oms-order-create-view.scss';

import './oms-order-edit-view/oms-order-edit-view.component';
import './oms-order-edit-view/oms-order-edit-view.scss';

import './oms-order-link/oms-order-link.component';
import './oms-order-link/oms-order-link.scss';

import './oms-order-price-overview-line-view/oms-order-price-overview-line-view';
import './oms-order-price-overview-line-view/oms-order-price-overview-line-view.scss';

import './oms-order-status/oms-order-status.component';
import './oms-order-status/oms-order-status.scss';

import './oms-order-status-select/oms-order-status-select.component';
import './oms-order-status-select/oms-order-status-select.scss';

import './oms-order-status-multi-select-list/oms-order-status-multi-select-list.component';
import './oms-order-status-multi-select-list/oms-order-status-multi-select-list.scss';

import './oms-order-timeline-logs/oms-order-timeline-logs.component';
import './oms-order-timeline-logs/oms-order-timeline-logs.scss';

import './oms-order-view/oms-order-view.component';
import './oms-order-view/oms-order-view.scss';

import './oms-orders-action-footer/oms-orders-action-footer.component';
import './oms-orders-action-footer/oms-orders-action-footer.scss';

import './oms-orders-group-select/oms-orders-group-select.component';
import './oms-orders-group-select/oms-orders-group-select.scss';

import './oms-package-list/oms-package-list.component';
import './oms-package-list/oms-package-list.scss';

import './oms-packages-info/oms-packages-info.component'
import './oms-packages-info/oms-packages-info.scss'

import './oms-orders-table/oms-orders-table.component';
import './oms-orders-table/oms-orders-table.scss';

import './oms-orders-table-row/oms-orders-table-row.component';
import './oms-orders-table-row/oms-orders-table-row.scss';

import './oms-orders-table-row-tasks/oms-orders-table-row-tasks.component';
import './oms-orders-table-row-tasks/oms-orders-table-row-tasks.scss';

import './oms-orders-view/oms-orders-view.component';
import './oms-orders-view/oms-orders-view.scss';

import './oms-packages-indication/oms-packages-indication.component';
import './oms-packages-indication/oms-packages-indication.scss';

import './oms-shipment-assign-table/oms-shipment-assign-table.component';
import './oms-shipment-assign-table/oms-shipment-assign-table.scss';

import './oms-shipment-assign-table-row/oms-shipment-assign-table-row.component';
import './oms-shipment-assign-table-row/oms-shipment-assign-table-row.scss';

import './oms-spots-indication/oms-spots-indication.component';
import './oms-spots-indication/oms-spots-indication.scss';

import './oms-validation-table/oms-validation-table.component';
import './oms-validation-table/oms-validation-table.scss';

import './oms-validation-table-row/oms-validation-table-row.component';
import './oms-validation-table-row/oms-validation-table-row.scss';

import './oms-view-settings-panel/oms-view-settings-panel.component';
import './oms-view-settings-panel/oms-view-settings-panel.scss';

import './oms-view-settings-panel/template/oms-view-settings-panel-template.component';
import './oms-view-settings-panel/template/oms-view-settings-panel-template.scss';

import './order-print-bill-of-lading/order-print-bill-of-lading.component';
import './order-print-bill-of-lading/order-print-bill-of-lading.scss';

import './oms-order-details-panel/oms-order-details-panel.component';
import './oms-order-details-panel/oms-order-details-panel.scss';

import './oms-order-sms-messages-view/oms-order-sms-messages-view.component';
import './oms-order-sms-messages-view/oms-order-sms-messages-view.scss';

import './oms-order-notes-panel/oms-order-notes-panel.component';
import './oms-order-notes-panel/oms-order-notes-panel.scss';

import './create-oms-return-delivery-dialog/create-oms-return-delivery-dialog.component';
import './create-oms-return-delivery-dialog/create-oms-return-delivery-dialog.scss';

import './oms-package-list-lean/oms-package-list-lean.component';
import './oms-package-list-lean/oms-package-list-lean.scss';

import './oms-order-fulfillment-line-notes/oms-order-fulfillment-line-notes.component';
import './oms-order-fulfillment-line-notes/oms-order-fulfillment-line-notes.scss';

import './oms-orders-table-row-task/oms-orders-table-row-task.component';
import './oms-orders-table-row-task/oms-orders-table-row-task.scss';

import './oms-orders-bulk-edit/oms-orders-bulk-edit.component';
import './oms-orders-bulk-edit/oms-orders-bulk-edit.scss';

import './oms-order-additions-multi-select/oms-order-additions-multi-select.component';
import './oms-order-additions-multi-select/oms-order-additions-multi-select.scss';
